export const categoryEntityType = 'category'
